import React from 'react'
import styles from './index.module.css'
import moment from 'moment';
import { useSelector } from 'react-redux';

const Index = ({ chats, selectedChat, setSelectedChat }) => {
    
    const photos = useSelector((state) => state.lk.photos);
    const {firstname,  lastname, patronymic} = useSelector((state) => state.auth);
  


    return (
    <div className={styles.wrapper}>
        {
            chats?.map(chat => {
                const date = moment(chat.updated || chat.created).utcOffset(0).format('DD.MM.YYYY HH:mm')
                return (
                    <div key={chat.id}>
                        <div className={styles.item + ' ' + (chat.id === selectedChat?.id ? styles.active : '')} onClick={() => setSelectedChat(chat)}>
                            {chat.countnew > 0 && <div className={styles.unreadCount}></div>}
                            <div className={styles.avatarWrapper}>
                                <img className={styles.avatar} src={photos[chat.photoid]} alt="" />
                            </div>
                            <div className={styles.info}>
                                <div className={styles.title}>Тема: {chat.title}</div>
                                <div className={styles.name}>{`${lastname} ${firstname} ${patronymic}` === chat.fromname ? chat.toname : chat.fromname}</div>
                                <div className={styles.messageAndTime}>
                                    <span className={styles.message}>{chat.last_message}</span> 
                                    <span className={styles.time}>{date}</span></div>
                            </div>
                        </div>
                    </div>
                )
            })
        }
    </div>
  )
}

export default Index